import { render, staticRenderFns } from "./main-section-residents-recent-moveouts.vue?vue&type=template&id=4035430d&scoped=true"
import script from "./main-section-residents-recent-moveouts.vue?vue&type=script&lang=js"
export * from "./main-section-residents-recent-moveouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035430d",
  null
  
)

export default component.exports